



































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
//import { userModule } from "@/store/modules/user";
//import AsesmenRisikoJatuh from "@/services/AsesmenRisikoJatuh";
import { appModule } from "@/store/modules/app";
import { confirmRemove } from "@/utility/CommonHelper";
import FormAuthorization from "@/mixins/FormAuthorization";
//import moment from "moment";
//import storeRefAsesmen from "@/store/modules/new/ReferensiAsesmen";
import RefSvc from "@/services/ReferensiAsuhanKeperawatan";
//import { trimStart } from "lodash";
//import { debounce } from "lodash";

@Component({
  components: {
    //
  }
})
export default class RefAskepRanapPage extends Mixins(FormAuthorization) {
  @Prop() register!: string;
  @Prop() rm!: string;

  activeTab = 0;

  headers = [
    { text: "Diagnosis", value: "diagnosis" },
    { text: "Etiologi", value: "etiologi" },
    { text: "Tanda/Gejala", value: "gejala" },
    { text: "Luaran", value: "luaran" },
    { text: "Intervensi Label", value: "intervensi" }
  ];

  intervensiHeaders = [
    { text: "Intervensi", value: "name", width: "18%" },
    { text: "Kategori", value: "item.*.category", width: "7%" },
    { text: "Tindakan", value: "item.*.name", width: "35%" },
    { text: "Implementasi", value: "item.*.implementation", width: "35%" },
    { text: "Aksi", value: "created_at", width: "5%" }
  ];

  selectProps = { openOnHover: true, offsetY: true };
  refDiag = [];
  searchDiag = null;
  searchGejala = null;
  searchEtiologi = null;
  expandIntervensi = [];
  expandLuaran = [];

  // Dialog visibility
  showIntervensiDialog = false;
  showSearchDialog = false;

  // Data for editing
  selectedDiagnosis: any = null;
  currentIntervensiList: any[] = [];
  selectedIntervensiToAdd: any[] = [];

  // Search functionality
  searchIntervensi = null;
  refIntervensiList: any[] = [];

  searchIntRowItem = null;

  // State Dialog Individual Tindakan
  dialogItemIntervensi = false;
  isEditItemIntervensi = false;
  editItemIndex = -1; // Melacak index jika sedang edit item yang sudah ada di list

  // Model form individual tindakan
  formItemIntervensi = {
    id: null,
    category: "",
    name: "",
    implementasi: "",
    need_text: false,
    options: [] as string[]
  };

  // Save state
  saving = false;

  //spinner save
  savingDiagId: string | null = null;
  savingColumn: string | null = null;

  itemOptionsCategory = ["observasi", "edukasi", "terapeutik", "kolaborasi"];

  setExpandIntervensi(id) {
    if (this.expandIntervensi.includes(id)) {
      this.expandIntervensi = this.expandIntervensi.filter(i => i !== id);
    } else {
      this.expandIntervensi.push(id);
    }
  }

  setExpandLuaran(id) {
    if (this.expandLuaran.includes(id)) {
      this.expandLuaran = this.expandLuaran.filter(i => i !== id);
    } else {
      this.expandLuaran.push(id);
    }
  }

  mounted() {
    this.getRefData();
    this.getRefIntervensi();
    this.getRefMasterData();
  }

  get diagList() {
    let list = this.refDiag;
    if (this.searchDiag) {
      list = list.filter(dt => dt.name.toLowerCase().includes(this.searchDiag));
    }

    if (this.searchGejala && this.searchGejala.length > 0) {
      list = list.filter(
        dt =>
          dt.gejala.filter(gj =>
            // gj.name.toLowerCase().includes(this.searchGejala)
            this.searchGejala
              .map(txt => txt.toLowerCase())
              .includes(gj.name.toLowerCase())
          ).length > 0
      );
    }

    if (this.searchEtiologi) {
      list = list.filter(
        dt =>
          dt.etiologi.filter(et =>
            et.name.toLowerCase().includes(this.searchEtiologi)
          ).length > 0
      );
    }

    return list;
  }

  getRefData() {
    RefSvc.getDiagnosis().then(resp => {
      this.refDiag = Object.freeze(resp.data || []);
    });
  }

  // Open intervensi edit dialog for a diagnosis
  openIntervensiDialog(diagnosis) {
    this.selectedDiagnosis = diagnosis;
    this.currentIntervensiList = [...diagnosis.intervensi];
    this.showIntervensiDialog = true;
  }

  getRefIntervensi(search = null) {
    RefSvc.getIntervensi().then(resp => {
      this.refIntervensiList = Object.freeze(resp.data || []);
    });
  }

  get intervensiTableList() {
    let list = this.refIntervensiList;
    if (this.searchIntRowItem) {
      list = list.filter(int =>
        int.name.toLowerCase().includes(this.searchIntRowItem.toLowerCase())
      );
    }
    return list;
  }

  get flattenedIntervensiList() {
    const flatList: any[] = [];
    this.intervensiTableList.forEach(int => {
      if (int.item && int.item.length > 0) {
        int.item.forEach((itm: any, idx: number) => {
          flatList.push({
            int: int,
            itm: itm,
            idx: idx,
            key: `${int.id}-${itm.id || idx}`
          });
        });
      }
    });

    return flatList;
  }

  // Computed property to filter ref intervensi
  get filteredRefIntervensi() {
    return this.refIntervensiList.filter(
      ref => !this.currentIntervensiList.some(curr => curr.id === ref.id)
    );
  }

  // Remove intervensi from current list
  removeIntervensi(index) {
    this.currentIntervensiList.splice(index, 1);
  }

  // Save intervensi to diagnosis
  saveIntervensi() {
    this.saving = true;
    this.savingDiagId = String(this.selectedDiagnosis.id);
    this.savingColumn = "intervensi";

    RefSvc.updateDiagnosisIntervensi(
      this.selectedDiagnosis.id,
      this.currentIntervensiList.map(int => int.id)
    )
      .then(resp => {
        const diagId = this.selectedDiagnosis.id;
        const diagIndex = this.refDiag.findIndex(d => d.id === diagId);

        if (diagIndex !== -1) {
          const newRefDiag = [...this.refDiag];
          newRefDiag[diagIndex] = {
            ...newRefDiag[diagIndex],
            intervensi: this.currentIntervensiList
          };
          this.refDiag = Object.freeze(newRefDiag) as any[];
        }

        this.showIntervensiDialog = false;
      })
      .catch(err => {
        console.error("Gagal simpan intervensi:", err);
      })
      .finally(() => {
        this.saving = false;
        this.savingDiagId = null;
        this.savingColumn = null;
      });
  }

  editItervensi(intervensi) {
    this.selectedIntervensiToEdit = JSON.parse(JSON.stringify(intervensi));
    this.inputIntervensiMode = "edit";
    this.showEditIntervensiDialog = true;
    this.showInlineItemForm = false;
  }

  showEditIntervensiDialog = false;
  selectedIntervensiToEdit = null;
  inputIntervensiMode = "create"; // or "edit"

  saveEditIntervensi() {
    if (!this.selectedIntervensiToEdit.id) {
      appModule.sendErrorAlert("ID Intervensi wajib diisi.");
      return;
    }

    if (!this.selectedIntervensiToEdit.name) {
      appModule.sendErrorAlert("Label Intervensi wajib diisi.");
      return;
    }

    if (
      !this.selectedIntervensiToEdit.item ||
      this.selectedIntervensiToEdit.item.length === 0
    ) {
      appModule.sendErrorAlert("Tindakan & Implementasi wajib diisi.");
      return;
    }

    this.saving = true;

    const Svc =
      this.inputIntervensiMode === "edit"
        ? RefSvc.updateIntervensi(
            this.selectedIntervensiToEdit.id,
            this.selectedIntervensiToEdit
          )
        : RefSvc.createIntervensi(this.selectedIntervensiToEdit);

    Svc.then(resp => {
      appModule.sendSuccessNotice(
        `Intervensi berhasil ${
          this.inputIntervensiMode === "edit" ? "diperbarui" : "dibuat"
        }`
      );
      this.showEditIntervensiDialog = false;
      this.getRefIntervensi();
    }).finally(() => {
      this.saving = false;
    });
  }

  @Watch("showEditIntervensiDialog")
  onShowEditIntervensiDialogChange(newVal) {
    if (!newVal) {
      this.selectedIntervensiToEdit = null;
      this.inputIntervensiMode = "create";
    }
  }

  addNewIntervensi() {
    this.selectedIntervensiToEdit = {
      id: "",
      name: "",
      item: []
    };
    this.inputIntervensiMode = "create";
    this.showEditIntervensiDialog = true;
  }

  showInlineItemForm = false;
  tempItemForm = {
    id: null,
    category: "",
    name: "",
    implementasi: "",
    need_text: false,
    options: []
  };

  openAddItemIntervensi() {
    this.tempItemForm = {
      id: null,
      category: "",
      name: "",
      implementasi: "",
      need_text: false,
      options: []
    };
    this.showInlineItemForm = true;

    this.$nextTick(() => {
      const tindakan = this.$refs.refInputTindakan as HTMLElement;
      if (tindakan) {
        tindakan.focus();
      }
    });
  }

  pushTempItemToList() {
    if (!this.tempItemForm.name) {
      appModule.sendErrorAlert("Tindakan wajib diisi");
      return;
    }
    if (!this.tempItemForm.implementasi) {
      appModule.sendErrorAlert("Implementasi wajib diisi");
      return;
    }

    if (!this.selectedIntervensiToEdit.item) {
      this.selectedIntervensiToEdit.item = [];
    }

    this.selectedIntervensiToEdit.item.push({
      ...this.tempItemForm,
      options: this.tempItemForm.options ? [...this.tempItemForm.options] : []
    });

    this.showInlineItemForm = false;
  }

  async saveMasterTindakanIntervensi() {
    if (!this.formItemIntervensi.name) {
      appModule.sendErrorAlert("Nama Tindakan wajib diisi");
      return;
    }

    this.saving = true;
    try {
      const payload = { ...this.formItemIntervensi };

      payload.options = Array.isArray(payload.options) ? payload.options : [];

      if (this.isEditItemIntervensi) {
        await RefSvc.updateMasterTindakan(payload.id, payload as any);
        appModule.sendSuccessNotice("Tindakan berhasil diperbarui");
      } else {
        await RefSvc.createMasterTindakan(payload as any);
        appModule.sendSuccessNotice("Tindakan berhasil ditambahkan");
      }

      this.getRefIntervensi();
      this.dialogItemIntervensi = false;
    } catch (error) {
      console.error("Gagal menyimpan tindakan:", error);
    } finally {
      this.saving = false;
    }
  }

  openEditTindakan(itm: any) {
    this.isEditItemIntervensi = true;

    this.formItemIntervensi = JSON.parse(JSON.stringify(itm));

    if (!Array.isArray(this.formItemIntervensi.options)) {
      this.formItemIntervensi.options = [];
    }

    this.dialogItemIntervensi = true;
  }

  // async deleteTindakan(itm: any, parentInt: any) {
  //   //tidak bisa hapus tindakan, hapus kode ini
  //   const confirm = await confirmRemove(`Tindakan: ${itm.name}`);
  //   if (!confirm) return;

  //   this.saving = true;
  //   try {
  //     // PANGGIL API HAPUS MASTER TINDAKAN DI SINI
  //     // await RefSvc.deleteMasterTindakan(itm.id);

  //     appModule.sendSuccessNotice("Tindakan berhasil dihapus");
  //     this.getRefIntervensi(); // Refresh tabel
  //   } catch (err) {
  //     console.error(err);
  //   } finally {
  //     this.saving = false;
  //   }
  // }

  get mapDiagIntervensi() {
    if (this.inputIntervensiMode !== "edit" || !this.selectedIntervensiToEdit)
      return [];

    const targetIntervensiId = this.selectedIntervensiToEdit.id;
    const mappingResult = [];

    this.refDiag.forEach(dataDiagnosis => {
      if (dataDiagnosis.intervensi && Array.isArray(dataDiagnosis.intervensi)) {
        const linkedIntervensi = dataDiagnosis.intervensi.find(
          intv => intv.id === targetIntervensiId
        );

        if (linkedIntervensi) {
          mappingResult.push({
            id: dataDiagnosis.id,
            name: dataDiagnosis.name
          });
        }
      }
    });

    return mappingResult;
  }

  async getRefMasterData() {
    try {
      const [respEt, respGj, respLuaran, respHasil] = await Promise.all([
        RefSvc.getEtiologi(),
        RefSvc.getGejala(),
        RefSvc.getLuaran(),
        RefSvc.getHasilLuaran()
      ]);

      this.refMasterEtiologiList = Object.freeze(respEt.data || []);
      this.refMasterGejalaList = Object.freeze(respGj.data || []);

      const luaranData = (respLuaran.data || []).map((item: any) => ({
        ...item,
        hasil: item.hasil || []
      }));
      this.refMasterLuaranList = Object.freeze(luaranData);

      this.refMasterHasilLuaranList = Object.freeze(respHasil.data || []);
    } catch (error) {
      console.error("Gagal mengambil data master:", error);
    }
  }

  //Master gejala
  searchGejalaDiag = "";
  showGejalaEditor = false;
  selectedDiagForGejala: any = null;
  currentGejalaItems: any[] = [];
  selectedGejalaToAdd: any = {};

  searchMasterGejala = "";
  dialogGejalaMaster = false;
  isEditGejalaMaster = false;
  formGejalaMaster = {
    id: "",
    name: "",
    need_text: false,
    options: [] as string[]
  };
  refMasterGejalaList: any[] = [];

  get filteredMasterGejala() {
    if (!this.searchMasterGejala) return this.refMasterGejalaList;
    const search = this.searchMasterGejala.toLowerCase();
    return this.refMasterGejalaList.filter(
      g =>
        (g.name || "").toLowerCase().includes(search) ||
        String(g.id).includes(search)
    );
  }

  get mapDiagGejala() {
    if (!this.isEditGejalaMaster) return [];

    const data = this.refMasterGejalaList.find(
      (g: any) => g.id === this.formGejalaMaster.id
    );

    if (data && data.diagnosis && Array.isArray(data.diagnosis)) {
      return data.diagnosis;
    }

    return [];
  }

  openDiagGejala(diagnosis: any) {
    this.selectedDiagForGejala = diagnosis;

    this.currentGejalaItems = (diagnosis.gejala || []).map((g: any) => ({
      id: g.id,
      name: g.name
    }));

    this.selectedGejalaToAdd = {};

    this.showGejalaEditor = true;
  }

  getAvailableGejala() {
    if (!this.currentGejalaItems || this.currentGejalaItems.length === 0) {
      return this.refMasterGejalaList;
    }

    const existingIds = this.currentGejalaItems.map((g: any) => String(g.id));

    return this.refMasterGejalaList.filter(
      m => !existingIds.includes(String(m.id))
    );
  }

  //Tambah Gejala ke List
  addGejalaItem(item: any) {
    if (!item) return;

    this.currentGejalaItems.push({
      id: item.id,
      name: item.name
    });

    this.selectedGejalaToAdd = {};
  }

  removeGejalaItem(index: number) {
    this.currentGejalaItems.splice(index, 1);
    this.selectedGejalaToAdd = {};
  }

  async saveDiagnosisGejala() {
    if (!this.selectedDiagForGejala) return;

    const hasEmptyRow = this.currentGejalaItems.some(item => !item.id);
    if (hasEmptyRow) {
      appModule.sendErrorAlert("Data gejala wajib diisi.");
      return;
    }

    this.saving = true;

    this.savingDiagId = String(this.selectedDiagForGejala.id);
    this.savingColumn = "gejala";

    try {
      const diagId = this.selectedDiagForGejala.id;

      // const formattedGejala = this.currentGejalaItems.map(item => ({
      //   gejala_id: item.id
      //   //name: item.name
      // }));
      const data = this.currentGejalaItems.map(item => String(item.id));

      const payload = {
        gejala_id: data
      };

      const isNew =
        !this.selectedDiagForGejala.gejala ||
        this.selectedDiagForGejala.gejala.length === 0;

      if (isNew) {
        await RefSvc.createGejala(diagId, payload);
      } else {
        await RefSvc.updateGejala(diagId, payload);

        const diagIndex = this.refDiag.findIndex(d => d.id === diagId);
        if (diagIndex !== -1) {
          const newRefDiag = [...this.refDiag];

          newRefDiag[diagIndex] = {
            ...newRefDiag[diagIndex],
            gejala: this.currentGejalaItems // Update list luaran
          };

          this.refDiag = Object.freeze(newRefDiag) as any[];
        }
      }

      appModule.sendSuccessNotice("Gejala Diagnosis berhasil diperbarui.");
      this.showGejalaEditor = false;
      this.getRefData();
    } catch (err) {
      console.error("Gagal simpan gejala:", err);
    } finally {
      this.saving = false;
      this.savingDiagId = null;
      this.savingColumn = null;
    }
  }

  openAddGejalaMaster() {
    this.isEditGejalaMaster = false;
    // const maxId = this.refMasterGejalaList.reduce((max, item) => {
    //   const id = parseInt(item.id);
    //   return id > max ? id : max;
    // }, 0);

    this.formGejalaMaster = {
      id: "", //(maxId + 1).toString(),
      name: "",
      need_text: false,
      options: [] as string[]
    };
    this.dialogGejalaMaster = true;
  }

  openEditGejalaMaster(item: any) {
    this.isEditGejalaMaster = true;
    this.formGejalaMaster = JSON.parse(JSON.stringify(item));
    this.dialogGejalaMaster = true;
  }

  searchTempGejala = "";

  async saveMasterGejala() {
    if (
      this.searchTempGejala &&
      this.searchTempGejala !== this.formGejalaMaster.name
    ) {
      this.formGejalaMaster.name = this.searchTempGejala;
    }

    const inputName = this.searchTempGejala || this.formGejalaMaster.name;

    if (!inputName) {
      appModule.sendErrorAlert("Gejala wajib diisi");
      return;
    }

    const isDuplicate = this.refMasterGejalaList.some(
      item =>
        item.name.toLowerCase() === inputName.toLowerCase() &&
        item.id !== this.formGejalaMaster.id
    );

    if (isDuplicate) {
      appModule.sendErrorAlert(
        `Gejala [ ${inputName} ] sudah ada. Silakan buat gejala yang berbeda!`
      );
      return;
    }

    this.saving = true;
    try {
      const payload = {
        //id: this.formGejalaMaster.id,
        name: this.formGejalaMaster.name,
        need_text: this.formGejalaMaster.need_text ? true : false,
        options: this.formGejalaMaster.options || []
      };

      if (this.isEditGejalaMaster) {
        await RefSvc.updateMasterGejala(this.formGejalaMaster.id, payload);
      } else {
        await RefSvc.createMasterGejala(payload);
      }

      appModule.sendSuccessNotice("Data Gejala berhasil disimpan");
      this.dialogGejalaMaster = false;
      this.getRefMasterData();
    } catch (err) {
      console.error(err);
    } finally {
      this.saving = false;
    }
  }

  async deleteGejalaMaster(item: any) {
    const confirm = await confirmRemove(`Gejala : [${item.id}] - ${item.name}`);
    if (!confirm) return;

    this.saving = true;
    try {
      await RefSvc.deleteMasterGejala(item.id);
      appModule.sendSuccessNotice("Gejala berhasil dihapus");
      this.getRefMasterData();
    } catch (err) {
      console.error(err);
    } finally {
      this.saving = false;
    }
  }

  //etiologi
  searchEtiologiDiag = "";
  showEtiologiEditor = false;
  selectedDiagForEtiologi: any = null;
  currentEtiologiItems: any[] = [];
  selectedEtiologiToAdd: any = {};
  searchMasterEtiologi = "";
  dialogEtiologiMaster = false;
  formEtiologiMaster = {
    id: "",
    name: "",
    need_text: false,
    options: [] as string[]
  };
  isEditEtiologiMaster = false;
  refMasterEtiologiList: any[] = [];

  get filteredMasterEtiologi() {
    if (!this.searchMasterEtiologi) return this.refMasterEtiologiList;
    const search = this.searchMasterEtiologi.toLowerCase();
    return this.refMasterEtiologiList.filter(
      e =>
        (e.name || "").toLowerCase().includes(search) ||
        String(e.id).includes(search)
    );
  }

  get mapDiagEtiologi() {
    if (!this.isEditEtiologiMaster) return [];

    const data = this.refMasterEtiologiList.find(
      (e: any) => e.id === this.formEtiologiMaster.id
    );

    if (data && data.diagnosis && Array.isArray(data.diagnosis)) {
      return data.diagnosis;
    }
    return [];
  }

  openDiagEtiologi(diagnosis: any) {
    this.selectedDiagForEtiologi = diagnosis;

    this.currentEtiologiItems = (diagnosis.etiologi || []).map((e: any) => ({
      id: e.id,
      name: e.name
    }));

    this.selectedEtiologiToAdd = {};

    this.showEtiologiEditor = true;
  }

  getAvailableEtiologi() {
    if (!this.currentEtiologiItems || this.currentEtiologiItems.length === 0) {
      return this.refMasterEtiologiList;
    }

    const existingIds = this.currentEtiologiItems.map((e: any) => String(e.id));

    return this.refMasterEtiologiList.filter(
      m => !existingIds.includes(String(m.id))
    );
  }

  // Tambah Etiologi ke List
  addEtiologiItem(item: any) {
    if (!item) return;

    this.currentEtiologiItems.push({
      id: item.id,
      name: item.name
    });

    this.selectedEtiologiToAdd = {};
  }

  // Hapus Etiologi dari List
  removeEtiologiItem(index: number) {
    this.currentEtiologiItems.splice(index, 1);
    this.selectedEtiologiToAdd = {};
  }

  async saveDiagEtiologi() {
    if (!this.selectedDiagForEtiologi) return;

    const hasEmptyRow = this.currentEtiologiItems.some(item => !item.id);
    if (hasEmptyRow) {
      appModule.sendErrorAlert("Data etiologi wajib diisi.");
      return;
    }

    this.saving = true;

    this.savingDiagId = String(this.selectedDiagForEtiologi.id);
    this.savingColumn = "etiologi";

    try {
      const diagId = this.selectedDiagForEtiologi.id;

      const formattedEtiologi = this.currentEtiologiItems.map(
        item => String(item.id)
        //name: item.name
      );

      const payload = {
        etiologi_id: formattedEtiologi
      };

      const isNew =
        !this.selectedDiagForEtiologi.etiologi ||
        this.selectedDiagForEtiologi.etiologi.length === 0;

      if (isNew) {
        await RefSvc.createEtiologi(diagId, payload);
      } else {
        await RefSvc.updateEtiologi(diagId, payload);

        const diagIndex = this.refDiag.findIndex(d => d.id === diagId);
        if (diagIndex !== -1) {
          const newRefDiag = [...this.refDiag];

          newRefDiag[diagIndex] = {
            ...newRefDiag[diagIndex],
            etiologi: this.currentEtiologiItems
          };

          this.refDiag = Object.freeze(newRefDiag) as any[];
        }
      }

      appModule.sendSuccessNotice(
        `Etiologi berhasil ${isNew ? "ditambahkan" : "diperbarui"}`
      );
      this.showEtiologiEditor = false;
      this.getRefData();
    } catch (err) {
      console.error(err);
    } finally {
      this.saving = false;
      this.savingDiagId = null;
      this.savingColumn = null;
    }
  }

  openAddEtiologiMaster() {
    this.isEditEtiologiMaster = false;
    // const maxId = this.refMasterEtiologiList.reduce((max, item) => {
    //   const id = parseInt(item.id);
    //   return id > max ? id : max;
    // }, 0);

    this.formEtiologiMaster = {
      id: "", //(maxId + 1).toString(),
      name: "",
      need_text: false,
      options: [] as string[]
    };
    this.dialogEtiologiMaster = true;
  }

  openEditEtiologiMaster(item: any) {
    this.isEditEtiologiMaster = true;
    this.formEtiologiMaster = JSON.parse(JSON.stringify(item));
    this.dialogEtiologiMaster = true;
  }

  searchTempEtiologi = "";

  async saveMasterEtiologi() {
    if (
      this.searchTempEtiologi &&
      this.searchTempEtiologi !== this.formEtiologiMaster.name
    ) {
      this.formEtiologiMaster.name = this.searchTempEtiologi;
    }

    const inputName = this.searchTempEtiologi || this.formEtiologiMaster.name;

    if (!inputName) {
      appModule.sendErrorAlert("Etiologi wajib diisi");
      return;
    }

    const isDuplicate = this.refMasterEtiologiList.some(
      item =>
        item.name.toLowerCase() === inputName.toLowerCase() &&
        item.id !== this.formEtiologiMaster.id
    );

    if (isDuplicate) {
      appModule.sendErrorAlert(
        `Etiologi [ ${inputName} ] sudah ada. Silakan buat etiologi yang berbeda!`
      );
      return;
    }

    this.saving = true;
    try {
      const payload = {
        //id: this.formEtiologiMaster.id,
        name: this.formEtiologiMaster.name,
        need_text: this.formEtiologiMaster.need_text ? true : false,
        options: this.formEtiologiMaster.options || []
      };

      if (this.isEditEtiologiMaster) {
        await RefSvc.updateMasterEtiologi(this.formEtiologiMaster.id, payload);
      } else {
        await RefSvc.createMasterEtiologi(payload);
      }

      appModule.sendSuccessNotice("Data Etiologi berhasil disimpan");
      this.dialogEtiologiMaster = false;
      this.getRefMasterData();
    } catch (err) {
      console.error(err);
    } finally {
      this.saving = false;
    }
  }

  async deleteEtiologiMaster(item: any) {
    const confirm = await confirmRemove(
      `Etiologi : [${item.id}] - ${item.name}`
    );
    if (!confirm) return;

    this.saving = true;
    try {
      await RefSvc.deleteMasterEtiologi(item.id);
      appModule.sendSuccessNotice("Etiologi berhasil dihapus");
      this.getRefMasterData();
    } catch (err) {
      console.error(err);
    } finally {
      this.saving = false;
    }
  }

  // hasil Luaran
  dialogHasilLuaran = false;
  isEditHasilLuaran = false;
  formHasilLuaran = {
    id: "",
    name: ""
    //luaran: []
  };

  showLuaranEditor = false;
  currentDiagLuaran: any[] = [];
  selectedMasterLuaranToAdd: any = null;
  searchLuaranMaster = "";

  refMasterLuaranList: any[] = [];
  refMasterHasilLuaranList: any[] = [];

  // List Master Luaran
  get filteredLuaranMasterList() {
    if (!this.searchLuaranMaster) return this.refMasterLuaranList;

    const search = this.searchLuaranMaster.toLowerCase();

    return this.refMasterLuaranList.filter((label: any) => {
      if (label.name && label.name.toLowerCase().includes(search)) {
        return true;
      }

      if (label.hasil && label.hasil.length > 0) {
        return label.hasil.some(
          (k: any) => k.name && k.name.toLowerCase().includes(search)
        );
      }

      return false;
    });
  }

  get flattenedLuaranList() {
    const flatList: any[] = [];
    this.filteredLuaranMasterList.forEach((label: any) => {
      if (label.hasil && label.hasil.length > 0) {
        label.hasil.forEach((krit: any, idx: number) => {
          flatList.push({
            label: label,
            krit: krit,
            idx: idx,
            key: `${label.id}-${krit.id || idx}`
          });
        });
      }
    });
    return flatList;
  }

  openAddHasilLuaran() {
    this.isEditHasilLuaran = false;
    // const maxId = this.refMasterHasilLuaranList.reduce((max, item) => {
    //   const id = parseInt(item.id);
    //   return id > max ? id : max;
    // }, 0);

    this.formHasilLuaran = {
      id: "", //(maxId + 1).toString(),
      name: ""
    };

    this.$nextTick(() => {
      this.dialogHasilLuaran = true;
    });
  }

  openEditHasilLuaran(item: any) {
    this.isEditHasilLuaran = true;
    this.formHasilLuaran = JSON.parse(JSON.stringify(item));

    this.$nextTick(() => {
      this.dialogHasilLuaran = true;
    });
  }

  validateHasilLuaran(value: any) {
    if (typeof value === "object" && value !== null) {
      this.formHasilLuaran.name = ""; // Reset
    }
  }

  searchTempHasil = "";

  async saveMasterHasilLuaran() {
    if (
      this.searchTempHasil &&
      this.searchTempHasil !== this.formHasilLuaran.name
    ) {
      this.formHasilLuaran.name = this.searchTempHasil;
    }

    const inputName = this.searchTempHasil || this.formHasilLuaran.name;

    if (!inputName) {
      appModule.sendErrorAlert("Kriteria Luaran wajib diisi");
      return;
    }

    const isDuplicate = this.refMasterHasilLuaranList.some(
      item =>
        item.name.toLowerCase() === inputName.toLowerCase() &&
        item.id !== this.formHasilLuaran.id
    );

    if (isDuplicate) {
      appModule.sendErrorAlert(
        `Kriteria Luaran [ ${inputName} ] sudah ada. Silakan buat kriteria luaran yang berbeda!`
      );
      return;
    }

    this.saving = true;
    try {
      const payload = {
        //id: this.formHasilLuaran.id,
        name: String(this.formHasilLuaran.name)
      };

      if (this.isEditHasilLuaran) {
        await RefSvc.updateMasterHasilLuaran(this.formHasilLuaran.id, payload);
      } else {
        await RefSvc.createMasterHasilLuaran(payload);
      }

      appModule.sendSuccessNotice("Kriteria Luaran berhasil disimpan");
      this.dialogHasilLuaran = false;
      this.getRefMasterData();
    } catch (err) {
      console.error(err);
    } finally {
      this.saving = false;
    }
  }

  get hasilLuaranMap() {
    const map: Record<string, any> = {};
    if (this.refMasterHasilLuaranList) {
      this.refMasterHasilLuaranList.forEach((item: any) => {
        map[item.id] = item;
      });
    }
    return map;
  }

  get mapHasilLuaran() {
    if (!this.isEditHasilLuaran) return [];

    const data = this.hasilLuaranMap[this.formHasilLuaran.id];

    if (data && data.luaran && Array.isArray(data.luaran)) {
      return data.luaran;
    }

    return [];
  }

  openDiagLuaran(diagnosis: any) {
    this.selectedDiagnosis = diagnosis;
    this.currentDiagLuaran = JSON.parse(JSON.stringify(diagnosis.luaran || []));
    this.selectedMasterLuaranToAdd = null;
    this.showLuaranEditor = true;
    this.expandLuaranTemp = [];
  }

  getAvailableHasilLuaran(groupIndex: number) {
    const currentGroup = this.currentDiagLuaran[groupIndex];

    if (!currentGroup || !currentGroup.hasil)
      return this.refMasterHasilLuaranList;

    const existingIds = currentGroup.hasil.map((h: any) => String(h.id));

    return this.refMasterHasilLuaranList.filter(
      (m: any) => !existingIds.includes(String(m.id))
    );
  }

  addMasterLuaranToDiag(item: any) {
    if (!item) return;

    this.currentDiagLuaran.push({
      id: item.id,
      name: item.name,
      hasil: item.hasil ? [...item.hasil] : []
    });

    this.selectedMasterLuaranToAdd = {};
  }

  removeLuaranGroup(index: number) {
    this.currentDiagLuaran.splice(index, 1);
  }

  get availableMasterLuaranForDiag() {
    if (!this.refMasterLuaranList || this.refMasterLuaranList.length === 0) {
      return [];
    }

    if (!this.currentDiagLuaran || this.currentDiagLuaran.length === 0) {
      return this.refMasterLuaranList;
    }

    // Filter agar luaran yang sudah ditambahkan tidak muncul lagi di dropdown
    const existingIds = new Set(
      this.currentDiagLuaran.map((g: any) => String(g.id))
    );
    return this.refMasterLuaranList.filter(
      (m: any) => !existingIds.has(String(m.id))
    );
  }

  expandLuaranTemp: string[] = [];

  detilExpandLuaran(id: string) {
    if (this.expandLuaranTemp.includes(id)) {
      this.expandLuaranTemp = this.expandLuaranTemp.filter(x => x !== id);
    } else {
      this.expandLuaranTemp.push(id);
    }
  }

  async saveDiagLuaran() {
    this.saving = true;

    this.savingDiagId = String(this.selectedDiagnosis.id);
    this.savingColumn = "luaran";

    try {
      const diagId = String(this.selectedDiagnosis.id);

      const luaranIds = this.currentDiagLuaran.map((g: any) => String(g.id));
      const payload = {
        luaran: luaranIds
      };

      await RefSvc.updateLuaran(diagId, payload);

      // Update Lokal State
      const diagIndex = this.refDiag.findIndex(d => d.id === diagId);
      if (diagIndex !== -1) {
        const newRefDiag = [...this.refDiag];

        newRefDiag[diagIndex] = {
          ...newRefDiag[diagIndex],
          luaran: this.currentDiagLuaran
        };

        // Bekukan ulang
        this.refDiag = Object.freeze(newRefDiag) as any[];
      }

      this.showLuaranEditor = false;
      this.saving = false;
      appModule.sendSuccessNotice("Luaran berhasil disimpan.");
    } catch (err) {
      console.error("Gagal menyimpan luaran:", err);
    } finally {
      this.saving = false;
      this.savingDiagId = null;
      this.savingColumn = null;
    }
  }

  async deleteHasilLuaranMaster(item: any) {
    const confirm = await confirmRemove(
      `Kriteria Luaran : [${item.id}] - ${item.name}`
    );
    if (!confirm) return;

    this.saving = true;
    try {
      await RefSvc.deleteMasterHasilLuaran(item.id);
      appModule.sendSuccessNotice("Kriteria Luaran berhasil dihapus");
      this.getRefMasterData();
    } catch (err) {
      console.error(err);
    } finally {
      this.saving = false;
    }
  }

  // Master Luaran
  dialogLabelLuaran = false;
  isEditLabel = false;
  selectedHasilToAdd: any = null;
  formLabelLuaran: any = {
    id: "",
    name: "",
    expectation: "",
    category: "",
    hasil: []
  };
  kategoriOptions = ["aktual", "risiko"];
  ekspektasiOptions = ["meningkat", "menurun", "membaik", "memburuk"];
  rulesIdLuaran = [
    (v: any) => !!v || "ID Luaran wajib diisi",
    (v: any) =>
      (v && v.length === 7) ||
      "ID harus terdiri dari awalan L. dan 5 digit angka"
  ];

  get availableHasilLuaranList() {
    if (
      !this.refMasterHasilLuaranList ||
      this.refMasterHasilLuaranList.length === 0
    ) {
      return [];
    }
    if (
      !this.formLabelLuaran.hasil ||
      this.formLabelLuaran.hasil.length === 0
    ) {
      return this.refMasterHasilLuaranList;
    }
    // Optimasi performa filter
    const existingIds = new Set(
      this.formLabelLuaran.hasil.map((k: any) => String(k.id))
    );
    return this.refMasterHasilLuaranList.filter(
      (m: any) => !existingIds.has(String(m.id))
    );
  }

  formatIdLuaran(val: string) {
    if (!val) {
      this.formLabelLuaran.id = "";
      return;
    }

    const digits = val.replace(/\D/g, "").substring(0, 5);

    if (val === "L" || val === "L.") {
      this.formLabelLuaran.id = val.toUpperCase();
    } else {
      this.formLabelLuaran.id = "L." + digits;
    }
  }

  formatVisualId(event: any) {
    const val = event.target.value;
    if (!val) return;

    // Ambil hanya angka, maksimal 5 digit
    const digits = val.replace(/\D/g, "").substring(0, 5);
    let formatted = "";

    if (val.toUpperCase() === "L" || val.toUpperCase() === "L.") {
      formatted = val.toUpperCase();
    } else {
      formatted = "L." + digits;
    }

    event.target.value = formatted;
  }

  get mapDiagLuaran() {
    if (!this.isEditLabel) return [];

    const data = this.refMasterLuaranList.find(
      (l: any) => l.id === this.formLabelLuaran.id
    );

    if (data && data.diagnosis && Array.isArray(data.diagnosis)) {
      return data.diagnosis;
    }
    return [];
  }

  showAutocompleteHasil = false;

  tambahItemHasilLuaran() {
    this.showAutocompleteHasil = true;

    this.$nextTick(() => {
      const autocomplete = this.$refs.autocompleteHasil as any;
      if (autocomplete) {
        autocomplete.focus();
      }
    });
  }

  openAddLuaranMaster() {
    this.isEditLabel = false;
    this.showAutocompleteHasil = false;
    this.formLabelLuaran = {
      id: "",
      name: "",
      expectation: "",
      category: "",
      hasil: []
    };
    this.selectedHasilToAdd = null;
    this.$nextTick(() => {
      this.dialogLabelLuaran = true;
    });
  }

  openEditLuaranMaster(item: any) {
    this.isEditLabel = true;
    this.showAutocompleteHasil = false;
    this.formLabelLuaran = {
      id: item.id,
      name: item.name,
      expectation: item.expectation || "",
      category: item.category || "",
      hasil: item.hasil ? JSON.parse(JSON.stringify(item.hasil)) : []
    };
    this.selectedHasilToAdd = null;
    this.dialogLabelLuaran = true;
  }

  removeHasilFromLuaran(index: number) {
    //this.formLabelLuaran.hasil.splice(index, 1);
    this.formLabelLuaran.hasil = this.formLabelLuaran.hasil.filter(
      (_, i) => i !== index
    );
  }

  addExistingHasilToLuaran(item: any) {
    if (!item) return;
    this.formLabelLuaran.hasil = [
      ...this.formLabelLuaran.hasil,
      {
        id: item.id,
        name: item.name
      }
    ];
    this.selectedHasilToAdd = null;
  }

  async saveMasterLuaran() {
    const validations = [
      { isValid: this.formLabelLuaran.id, field: "ID Luaran" },
      { isValid: this.formLabelLuaran.name, field: "Luaran" },
      {
        isValid: this.formLabelLuaran.expectation,
        field: "Ekspektasi Luaran"
      },
      {
        isValid:
          this.formLabelLuaran.hasil && this.formLabelLuaran.hasil.length > 0,
        field: "Kriteria Luaran"
      }
    ];

    const emptyFields = validations.filter(v => !v.isValid).map(v => v.field);

    if (emptyFields.length > 0) {
      const errorMessage = `${emptyFields.join(", ")} wajib diisi.`;

      appModule.sendErrorAlert(errorMessage);
      return;
    }

    this.saving = true;
    try {
      const editPayload = {
        name: this.formLabelLuaran.name,
        expectation: this.formLabelLuaran.expectation,
        category: this.formLabelLuaran.category,
        hasil: this.formLabelLuaran.hasil.map((k: any) => String(k.id))
      };

      const addPayload = {
        id: String(this.formLabelLuaran.id),
        ...editPayload
      };

      const updateDiagPayload = {
        hasil_id: (this.formLabelLuaran.hasil || []).map((k: any) =>
          String(k.id)
        )
      };

      if (this.isEditLabel) {
        await RefSvc.updateMasterLuaran(this.formLabelLuaran.id, editPayload);
        await RefSvc.updateLuaranHasil(
          this.formLabelLuaran.id,
          updateDiagPayload
        );

        const index = this.refMasterLuaranList.findIndex(
          (x: any) => x.id === this.formLabelLuaran.id
        );
        if (index !== -1) {
          const newList = [...this.refMasterLuaranList];
          newList[index] = {
            ...newList[index],
            ...editPayload,
            hasil: this.formLabelLuaran.hasil
          };
          this.refMasterLuaranList = Object.freeze(newList) as any[];
        }
      } else {
        const res = await RefSvc.createMasterLuaran(addPayload);
        const newItem = {
          ...res,
          hasil: this.formLabelLuaran.hasil,
          luaran: []
        };
        //this.refMasterLuaranList.push(newItem);
        this.refMasterLuaranList = Object.freeze([
          ...this.refMasterLuaranList,
          newItem
        ]) as any[];
        await RefSvc.updateLuaranHasil(
          this.formLabelLuaran.id,
          updateDiagPayload
        );
      }

      appModule.sendSuccessNotice("Data Luaran berhasil disimpan");
      this.dialogLabelLuaran = false;

      this.getRefMasterData();
    } catch (err) {
      console.error(err);
      await this.getRefMasterData();
    } finally {
      this.saving = false;
    }
  }

  async deleteLuaranMaster(item: any) {
    const confirm = await confirmRemove(`Label Luaran: ${item.name}`);
    if (!confirm) return;

    this.saving = true;
    try {
      await RefSvc.deleteMasterLuaran(item.id);
      appModule.sendSuccessNotice("Label Luaran berhasil dihapus");
      this.getRefMasterData();
    } catch (err) {
      console.error(err);
    } finally {
      this.saving = false;
    }
  }

  highlightText(text, searchKeyword) {
    if (!text) return "-";

    if (!searchKeyword) return text;

    const safeKeyword = searchKeyword.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regex = new RegExp(`(${safeKeyword})`, "gi");

    return text
      .toString()
      .replace(regex, '<mark class="warning lighten-3">$1</mark>');
  }
}
